import { ReportsDisplayType } from '@screens/Reports/types/reportsScreen.type';

export const REPORTS_DISPLAYS = [
  { label: 'navigation.map', value: ReportsDisplayType.map },
  { label: 'navigation.list', value: ReportsDisplayType.list },
];

export const REPORTS_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];
export const REPORTS_PAGE_LIMIT = REPORTS_PAGE_SIZE_OPTIONS[0];
